import qs from 'qs';
import axios from 'axios';
import * as ADMIN_USERS_ACTION_TYPES from './constants';
import {
    push
} from 'react-router-redux/actions';
import {
    getAdminUsersFilterByType,
    getToken,
    getAdminUsersFilterBySearch,
    getAdminUsersPage
} from '../../selectors';
import {
    USERS_PER_PAGE
} from '../../constants';
import {
    API
} from '../../index';
import {
    PAGE_ADMIN
} from '../../App';

export const changePageToUserEditForm = userId => dispatch => {
    dispatch(push(PAGE_ADMIN.User + '/' + userId));
}

export const setAdminUsersPage = page => dispatch => {
    dispatch(setPage(page));
    dispatch(push(PAGE_ADMIN.Users + '/' + page));
    dispatch(getAndLoadAdminUsers());
}

export const getAdminUsersAfterFilterChangeAsync = () => dispatch => {
    dispatch(setPage(1));
    dispatch(push(PAGE_ADMIN.Users + '/1'));
    dispatch(getAndLoadAdminUsers());
};

export const setAdminUsersFilterByTypeAsync = type => dispatch => {
    dispatch(setFilterByType(type));
    dispatch(setPage(1));
    dispatch(push(PAGE_ADMIN.Users + '/1'));
    dispatch(getAndLoadAdminUsers());
}

export const setAdminUsersFilterBySearchAsync = search => dispatch => {
    dispatch(setFilterBySearch(search));
}

export const refetchAdminUsersAsync = () => dispatch => {
    dispatch(getAndLoadAdminUsers());
}

const fetchAdminUsers = (page, type, search, token) => {
    return new Promise((resolve, reject) => {
        return axios.get(API + 'user?' + qs.stringify({
            search: typeof search === 'string' && search !== '' ? search.trim() : undefined,
            typeId: type !== null ? type : undefined,
            $limit: USERS_PER_PAGE,
            $skip: typeof page === 'number' ? ((page * USERS_PER_PAGE) - USERS_PER_PAGE) : 0,
            $sort: {
                createdAt: -1,
            },
        }), {
            headers: {
                'Authorization': token,
            },
        }).then(response => {
            return resolve(response.data);
        }).catch(error => {
            console.error('Error in fetchAdminUsers: ', error);
            return reject(error);
        });
    });
}

const getAndLoadAdminUsers = () => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        const store = getState();
        const page = getAdminUsersPage(store);
        const filterByType = getAdminUsersFilterByType(store);
        const filterBySearch = getAdminUsersFilterBySearch(store);
        const token = getToken(store);

        dispatch(setLoadingError(false));
        dispatch(setLoadingStatus(true));

        fetchAdminUsers(page, filterByType, filterBySearch, token).then(response => {
            dispatch(setUsers(response.data.map(user => ({
                ...user,
                allowedReports: typeof allowedReports === 'string' ?
                    user.allowedReports.indexOf(',') === -1 ?
                    [parseInt(user.allowedReports, 10)] :
                    user.allowedReports.slice(',').map(reportId => parseInt(reportId, 10)) :
                    [],
            }))));
            dispatch(setUsersTotal(response.total));
            dispatch(setLoadingStatus(false));

            return resolve(true);
        }).catch(error => {
            dispatch(setLoadingError(true));
            dispatch(setLoadingStatus(false));

            console.error('Error in getAndLoadAdminUsers: ', error);
            return reject(false);
        });
    });
}

const setPage = page => ({
    type: ADMIN_USERS_ACTION_TYPES.SET_PAGE,
    payload: page,
});

const setFilterByType = type => ({
    type: ADMIN_USERS_ACTION_TYPES.SET_FILTER_BY_TYPE,
    payload: type,
});

const setFilterBySearch = search => ({
    type: ADMIN_USERS_ACTION_TYPES.SET_FILTER_BY_SEARCH,
    payload: search,
});

const setLoadingStatus = isLoading => ({
    type: ADMIN_USERS_ACTION_TYPES.SET_IS_LOADING,
    payload: typeof isLoading === 'boolean' ? isLoading : undefined,
});

const setLoadingError = isError => ({
    type: ADMIN_USERS_ACTION_TYPES.SET_LOADING_ERROR,
    payload: typeof isError === 'boolean' ? isError : undefined,
});

const setUsers = users => ({
    type: ADMIN_USERS_ACTION_TYPES.SET_USERS,
    payload: users,
});

const setUsersTotal = total => ({
    type: ADMIN_USERS_ACTION_TYPES.SET_USERS_TOTAL,
    payload: total,
});



// WEBPACK FOOTER //
// ./app/web/src/container/AdminUsersPage/action.js